export default {
  主页面标题: "Sourcing Requirement Management",
  申请寻源按钮: "Apply for Sourcing",
  导入寻源计划按钮: "Import Sourcing Plan",
  导入寻源计划: "Import Sourcing Plan",
  导入关闭: "Close",
  导入确认: "Confirm",
  寻源类型: "Sourcing Type",
  点击下载: "Click to Download",
  下载模版: "Download Template",
  寻源计划文件: "Sourcing Plan File",
  请上传寻源计划文件: "Upload Sourcing Plan File",
  点击上传: "Upload",
  寻源信息: "Sourcing Information",
  工厂: "Factory",
  请选择工厂: "Please select factory",
  寻源类别: "Sourcing Category",
  请选择寻源类别: "Please select sourcing category",
  寻源二级类别: "Sourcing Subcategory",
  请选择二级寻源类别: "Please select subcategory",
  成本中心: "Cost Center",
  请选择成本中心: "Please select cost center",
  序号: "No.",
  物料编号: "Material Code",
  物料名称: "Material Name",
  年采购数量: "Annual Quantity",
  请输入编号: "Enter code",
  请输入物料名称: "Enter material name",
  请输入年采购数量: "Enter annual quantity",
  相关产品: "Related Product",
  请输入相关产品: "Enter related product",
  请输入要求完成日期: "Enter completion date",
  寻源原因: "Sourcing Reason",
  请输入寻源原因: "Enter sourcing reason",
  寻源要求: "Sourcing Requirements",
  请输入寻源要求: "Enter sourcing requirements",
  寻源优先级: "Priority",
  紧急: "Urgent",
  一般: "Normal",
  取消寻源: "Cancel Sourcing",
  取消原因: "Cancel Reason",
  寻源来源: "Sourcing Source",
  寻源方法: "Sourcing Method",
  计划开始时间: "Planned Start Date",
  计划结束时间: "Planned End Date",
  寻源执行: "Sourcing Execution",
  查看寻源进度: "View Progress",
  寻源名称: "Sourcing Name",
  需求数量: "Required Quantity",
  单价HKD: "Unit Price HKD",
  总金额HKD: "Total Amount HKD",
  相关附件: "Related Attachments",
  现有标准物料文件: "Standard Material Files",
  现有供应商COA: "Supplier COA",
  URS文件: "URS Files",
  其他: "Others",
  取消寻源原因: "Cancel Sourcing Reason",
  取消成功: "Cancelled successfully",
  请输入取消寻源的原因: "Enter reason for cancellation",
  表单底部暂存: "Save as Draft",
  表单底部提交: "Submit",
  提交成功: "Submitted successfully",
  寻源物料产品正在处方变更: "Product is under formulation change",
  物料质量标准确认: "Material Quality Standard Confirmation",
  供应商开发和筛选: "Supplier Development and Screening",
  供应商选择和评估: "Supplier Selection and Evaluation",
  供应商合格认证: "Supplier Qualification (Original Admission)",
  提供URS: "Provide URS",
  用户与供应商技术沟通: "Technical Communication with Supplier",
  采购与供应商商务沟通: "Business Communication with Supplier",
  汇总技术与商务资料: "Summarize Technical and Business Data",
  采购委员会获批: "Procurement Committee Approval",
  合同签署获批: "Contract Signing Approval",
  寻源需求申请: "Sourcing Requirement Application",
  寻源节点跟进: "Sourcing Node Follow-up",
  全部展开: "Expand All",
  全部折叠: "Collapse All",
  操作成功: "Success",
  完成节点: "Complete Node",
  已完成: "Completed",
  待完成: "Pending",
  展开: "Expand",
  折叠: "Collapse",
  点击选择供应商: "Click to Select Supplier",
  处方变更确认: "Formulation Change Confirmation",
  寻源物料之产品是否正在处方变更: "Is the product under formulation change?",
  请选择产品是否正在处方变更: "Select if product is under formulation change",
  预计处方变更完成时间: "Expected Completion Date",
  请选择预计处方变更完成时间: "Select expected completion date",
  物料标准确认: "Material Standard Confirmation",
  现有物料标准是否可用于寻源: "Existing material standard available",
  请选择现有物料标准是否可用于寻源: "Select if existing standard can be used",
  新标准物料文件: "New Standard Material File",
  生产性物料: "Production Materials",
  非生产性物料: "Non-production Materials",
  当前节点完成后无法取消: "Once completed, this node cannot be cancelled",
  寻源节点维护流程: "Sourcing Node Maintenance Process",
  寻源申请状态: "Application Status",
  寻源执行状态: "Sourcing Status",
  未开始: "Not Started",
  进行中: "In Progress",
  已取消: "Cancelled",
  寻源数量: "Sourcing Count",
  二级寻源类别: "Subcategory",
  寻源负责人: "Sourcing Owner",
  负责人: "Owner",
  搜索物料编号名称占位符: "Enter material code or name",
  重新提交: "Resubmit",
  单价: "Unit Price",
  总金额: "Total Amount",
  请输入: "Please enter",
  请选择: "Please select",
  表单编号: "Form Number",
  物料: "Material",
  申请人: "Applicant",
  要求完成日期: "Required Completion Date",
};
